import React from "react";

const IconErrorBig = () => (
  <svg
    width="126"
    height="115"
    viewBox="0 0 126 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.4149 7.38614C68.9313 4.69891 66.0368 3 62.868 3C59.7048 3 56.8048 4.69891 55.3239 7.38614L3.59865 99.6148C2.12343 102.169 2.18501 105.308 3.73582 107.87C5.28383 110.426 8.11671 112 11.1427 112H114.596C117.625 112 120.455 110.426 122.003 107.87C123.551 105.308 123.624 102.169 122.14 99.6148L70.4149 7.38614Z"
      stroke="#DE5E5C"
      strokeWidth="5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.6611 70.2169H64.2741V30.25H58.6611V70.2169ZM58.6611 84.75H64.2741V77.4848H58.6611V84.75Z"
      fill="#DE5E5C"
    />
  </svg>
);

export default IconErrorBig;
